export interface IRoundScore {
  game: number;
  gross: number;
  handicap: number;
  holeHandicap: number;
  holePar: number;
  id: number;
  net: number;
  order: number;
  original: number;
}

export interface IRoundScoresStore {
  [groupId: number]: IRoundScore[];
}

export const roundScoresStore: IRoundScoresStore = {};
